import axios from 'axios'

const baseURL = ' https://www.urblozinski.com/mail'

const apiBaseURL = axios.create({
	baseURL,
})

export default apiBaseURL
